import util from '@bmp-vue/core/api/util'

const controller = 'OperadorFrontEndConta'
export default Object.assign({}, util.GetCrud(controller, null), {
  GetByOperador: function (id) {
    return util.Axios.Get(controller + '/GetByOperador', id)
  },
  AlterarOperadorFrontEndConta: function (id, dto) {
    return util.Axios.Put(controller, id, dto)
  },
  GetPerfil: function () {
    return util.Axios.GetAll(controller + '/GetPerfil')
  },
  RemoverRelacaoOperadorConta: function (codigoOperadorFrontEnd, codigoConta) {
    const dto = { CodigoOperadorFrontEnd: codigoOperadorFrontEnd, CodigoConta: codigoConta }
    return util.Axios.DeleteAll(controller + '/RemoverRelacaoOperadorConta', dto)
  },
})
